import { FeatureAvailability, TicketFeature } from 'apollo/types';
import { FeatureIconVariant } from 'components/generalUI/FeatureIcon';

const getFeatureIconVariant = (
  feature: TicketFeature,
  index: number
): FeatureIconVariant => {
  if (feature.availability === FeatureAvailability.AccordingToAvailability) {
    return 'availability';
  }
  return index % 2 ? 'light' : 'dark';
};

export default getFeatureIconVariant;
